import React from 'react';
import Input, { SelectOption } from 'src/app/atoms/Input/Input';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import Typography from 'src/app/atoms/Typography/Typography';
import Badge, { BadgeProps } from 'src/app/molecules/Badge/Badge';
import { MoneyElement } from './RevenueCalculatorInput.styles';
import HelpCircleHint from '../HelpCircleHint/HelpCircleHint';
import { cssVar } from 'src/app/styles/helper';

export interface RevenueCalculatorInputProps {
  label: string;
  value: number | string;
  money?: boolean;
  onChange?: (value: number | string) => void;
  rightPlaceholder?: string;
  hint?: string;
  inputHint?: string;
  disabled?: boolean;
  type?: 'text' | 'number' | 'select';
  max?: number;
  min?: number;
  rightBadge?: BadgeProps;
  options?: SelectOption[];
  placeholder?: string;
}

const RevenueCalculatorInput = ({
  label,
  value,
  onChange,
  rightPlaceholder,
  hint,
  disabled = false,
  max,
  min,
  type = 'text',
  money,
  inputHint,
  rightBadge,
  options,
  placeholder,
}: RevenueCalculatorInputProps): JSX.Element => {
  return (
    <Input
      value={value.toString()}
      size='md'
      label={label}
      disabled={disabled}
      actionable={true}
      fontFamily='font-family-body'
      fontSize='font-size-text-lg'
      fontWeight='font-weight-semibold'
      lineHeight='line-height-text-lg'
      onChange={onChange}
      type={type}
      labelBreakpoint='lg'
      hint={inputHint}
      max={max}
      min={min}
      options={options}
      placeholder={placeholder}
      leftElement={
        money && (
          <MoneyElement>
            <Typography
              type='paragraph'
              size='lg'
              fontWeight='font-weight-semibold'
              color='text-primary'
            >
              $
            </Typography>
          </MoneyElement>
        )
      }
      rightElement={
        <Stack
          direction='row'
          gap='spacing-md'
          align='center'
        >
          {rightPlaceholder && (
            <Typography
              type='paragraph'
              size='sm'
              color='text-placeholder'
              whiteSpace='nowrap'
            >
              {rightPlaceholder}
            </Typography>
          )}
          {rightBadge && <Badge {...rightBadge} />}
          {hint && (
            <HelpCircleHint
              hint={hint}
              id={`${label}-hint`}
              color={cssVar('fg-brand-primary')}
            />
          )}
        </Stack>
      }
    />
  );
};

export default RevenueCalculatorInput;
